import React from 'react';
import { Card, CardContent, Typography, Button, List, ListItem, ListItemText } from '@mui/material';

const PricingCard = ({ title, price, originalPrice, features }) => {
  return (
    <Card
      sx={{
        width: '350px',           // Fixed width for all cards
        height: '500px',          // Fixed height for all cards
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        boxShadow: 6,
        transition: '0.5s',
        '&:hover': { boxShadow: 12, transform: 'scale(1.05)' },
        background: 'linear-gradient(135deg, #27548A, #183B4E)',  
        color: '#F5EEDC',
        borderRadius: '12px'
      }}
    >
      <CardContent>
        <Typography variant="h5" color="#DDA853">{title}</Typography>
        <Typography variant="h6" sx={{ textDecoration: 'line-through', color: '#ccc' }}>
          {originalPrice}
        </Typography>
        <Typography variant="h4" sx={{ color: '#DDA853', fontWeight: 'bold' }}>{price}</Typography>
        <List>
          {features.map((feature, idx) => (
            <ListItem key={idx}>
              <ListItemText primary={feature} />
            </ListItem>
          ))}
        </List>
      </CardContent>
      {/* <Button 
        variant="contained" 
        sx={{ backgroundColor: '#DDA853', color: '#183B4E', m: 2, borderRadius: '20px' }}
      >
        Choose Plan
      </Button> */}
    </Card>
  );
};

export default PricingCard;
